// src/lib/api/core/auth.js
import { supabase } from '../../supabase'
import { getValidatedCompanyId } from '../shared/helpers'
import { withErrorHandling } from '../shared/errors'

/**
 * Get current authenticated user
 */
const _getCurrentUser = async () => {
  const { data: { user }, error } = await supabase.auth.getUser()
  if (error) {
    console.error('[supabaseApi] Error getting user:', error)
    throw error
  }
  return user
}

/**
 * Check if user is authenticated
 */
const _isAuthenticated = async () => {
  const user = await _getCurrentUser()
  return user !== null
}

/**
 * Get user's company ID
 */
const _getUserCompanyId = async () => {
  return await getValidatedCompanyId()
}

/**
 * Sign out current user
 */
const _signOut = async () => {
  const { error } = await supabase.auth.signOut()
  if (error) {
    console.error('[supabaseApi] Error signing out:', error)
    throw error
  }
  return { success: true }
}

// Export wrapped functions with error handling
export const getCurrentUser = withErrorHandling(_getCurrentUser, 'get current user', 'user')
export const isAuthenticated = withErrorHandling(_isAuthenticated, 'check authentication', 'auth')
export const getUserCompanyId = withErrorHandling(_getUserCompanyId, 'get user company ID', 'company')
export const signOut = withErrorHandling(_signOut, 'sign out user', 'auth')

// Re-export shared helpers for convenience
export { getCompanyIdForUser, getValidatedCompanyId, clearHelperCompanyIdCache as clearCompanyIdCache } from '../shared/helpers'